﻿/* eslint-disable max-len */

export const PRODUCTS = 'products';
export const HEADER_ORDER_PRODUCTS = 'Order Products';
export const ORDER_MORE = 'Your checkin has been submitted! If you would like to order more products, please do so below.';
export const EXIT = 'Exit';
